import { OptionDto } from "@/dtos";

const tripTicketsFilters = [
    { value: 1, label: 'Actuales', tooltip: 'Visualizar las transacciones más recientes' },
    { value: 2, label: 'Histórico', tooltip: 'Visualizar las transacciones más antiguas de acuerdo al sistema' }
] as OptionDto[];

export const getTripTicketsFilters = (): OptionDto[] => {
    return tripTicketsFilters;
}